import InvalidCategory from '../exceptions/file_with_context/invalid_category'
import InvalidDocumentType from '../exceptions/file_with_context/invalid_document_type'
import InvalidInvoiceType from '../exceptions/file_with_context/invalid_invoice_type'
import InvalidIssuedBy from '../exceptions/file_with_context/invalid_issued_by.JS'
import InvalidType from '../exceptions/file_with_context/invalid_type'
import UnableToReadFile from '../exceptions/file_with_context_result/unable_to_read'
import InvalidDateFormat from '../exceptions/invalid_date_format'
import InvalidNumberFormat from '../exceptions/invalid_number_format'
import Missing from '../exceptions/missing'
import FileWithContextResult from './file_with_context_result'
import Relation from './relation'

const moment = require('moment')

class FileWithContext {
  #id
  #category
  #type
  #document_type
  #issued_by
  #issue_date
  #deadline
  #amount_incl_vat
  #amount_excl_vat
  #intervention_date
  #updated_at
  #purpose
  #copro_id
  #staff_id
  #provider
  #url
  #file
  #relation
  #shared
  #invoice_type

  #requiredField = {}
  #upload_by
  #upload_by_type

  static CATEGORY = {
    TECHNICAL: 'technical',
    ADMINISTRATIVE: 'administrative',
    LEGAL: 'legal',
    ACCOUNTING: 'accounting',
    BUILDING: 'building',
    CONTRACT: 'contract',
    RH: 'rh',
    INSURANCE: 'insurance',
    COMMUNICATION: 'communication',
  }

  static INVOICE_TYPE = {
    PRIVATE: 'private',
    COLLECTIVE: 'collective',
  }

  static TYPE = {
    PLAN: 'plan',
    INTERVENTION_PHOTO: 'intervention-photo',
    INDIVIDUAL_BURDEN_DISTRIBUTIONS: 'individual-burden-distributions',
    BANK_STATEMENTS: 'bank-statements',
    QUOTE: 'quote',
    INVOICE: 'invoice',
    INSURANCE_CERTIFICATE: 'insurance-certificate',
    CONTRACT_INSURANCE: 'contract-insurance',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    SPECIAL_CONDITIONS: 'special-conditions',
    INTERVENING_CONDITIONS: 'intervening-conditions',
    INTERVENTION_REPORT: 'intervention-report',
    ANALYSIS_OR_EXPERT_REPORT: 'analysis-or-expert-report',
    PV: 'pv',
    PV_SIGNED: 'pv-signed',
    COOWNERSHIP_RULES: 'coownership-rules',
    COOWNERSHIP_MODIFICATIONS: 'coownership-modifications',
    RH_WORK_CONTRACT: 'rh-work-contract',
    RH_SECURITY: 'rh-security',
    RH_MONITORING: 'rh-monitoring',
    RH_PENSION: 'rh-pension',
    DESCRIPTIVE_STATEMENT_DIVISION: 'descriptive-statement-division',
    ASBESTOS_DIAGNOSIS: 'asbestos-diagnosis',
    LEAD_DIAGNOSIS: 'lead-diagnosis',
    TERMITE_DIAGNOSIS: 'termite-diagnosis',
    REGISTRATION: 'registration',
    OTHERS: 'others',
    EMAIL: 'email',
    DTG: 'dtg',
    PPT: 'ppt',
    DPE: 'dpe',
    CONTRACT: {
      SYNDIC: 'syndic',
      SYNDIC_SIGNED: 'syndic-signed',
      WATER: 'water',
      GAS: 'gas',
      CLEANING_COMMON_AREAS: 'cleaning-common-areas',
      ELECTRICITY: 'electricity',
      ELEVATOR: 'elevator',
      BOILER_ROOM_MAINTENANCE: 'boiler-room-maintenance',
      DOOR_MANTINENCE: 'door-mantinence',
      PEST_CONTROL: 'pest-control',
      RAT_EXTERMINATION: 'rat-extermination',
      MAINTENANCE_DRY_RISERS: 'maintenance-dry-risers',
      DISCONNECTION_MAINTENANCE: 'disconnection-maintenance',
      SMOKE_EXTRACTION_MAINTENANCE: 'smoke-extraction-maintenance',
      PUMP_MAINTENANCE: 'pump-maintenance',
      WATER_METER_READING: 'water-meter-reading',
      GAS_METER_READING: 'gas-meter-reading',
      EMERGENCY_LIGHTING: 'emergency-lighting',
      PARKING_EXTRACTOR: 'parking-extractor',
      FILE_ALARM_MAINTENANCE: 'file-alarm-maintenance',
      FIRE_EXTINGUISHER_MAINTENANCE: 'fire-extinguisher-maintenance',
      VMC_MAINTENANCE: 'VMC-maintenance',
      BOOSTER_MAINTENANCE: 'booster-maintenance',
      ROOF_MAINTENANCE: 'roof-maintenance',
      ARCHIVE_MANAGEMENT: 'archive-management',
      DISCONNEXION: 'disconnexion',
      ASSURANCE: 'assurance',
    },
  }
  static DOCUMENT_TYPE = {
    COPRO: 'copro',
    INTERVENTION: 'intervention',
    AG: 'ag',
    CONTRACT: 'contract',
  }
  static ISSUED_BY = {
    HELLO_APP: 'hello-app',
    FRONT_PLUGIN: 'front-plugin',
  }

  static SHARED = {
    NOT: 'not',
    COOWNERS: 'coowners',
    PROVIDERS: 'providers',
    CS_MEMBERS: 'cs_members',
  }

  constructor(
    {
      id,
      category,
      type,
      document_type,
      issued_by,
      issue_date,
      deadline,
      amount_incl_vat,
      amount_excl_vat,
      intervention_date,
      updated_at,
      purpose,
      copro_id,
      staff_id,
      provider,
      url,
      file,
      shared,
      invoice_type,
      rel,
      upload_by,
      upload_by_type,
    },
    requiredField
  ) {
    if (requiredField) this.#requiredField = requiredField
    if (id) this.id = id
    if (rel) this.relation = rel
    if (updated_at) this.updated_at = updated_at
    this.purpose = purpose
    this.category = category
    this.type = type
    this.document_type = document_type
    this.issued_by = issued_by
    this.issue_date = issue_date
    this.copro_id = copro_id
    this.staff_id = staff_id
    this.provider = provider
    if (
      [
        FileWithContext.TYPE.INTERVENTION_REPORT,
        FileWithContext.TYPE.ANALYSIS_OR_EXPERT_REPORT,
      ].indexOf(this.type) > -1
    ) {
      this.intervention_date = intervention_date
    }
    if (
      [
        FileWithContext.TYPE.QUOTE,
        FileWithContext.TYPE.INVOICE,
        FileWithContext.TYPE.INSURANCE_CERTIFICATE,
      ].indexOf(this.type) > -1
    ) {
      this.deadline = deadline
      this.amount_incl_vat = amount_incl_vat
      this.amount_excl_vat = amount_excl_vat
    }
    if (FileWithContext.TYPE.INVOICE === this.type)
      this.invoice_type = invoice_type
    this.url = url
    if (!url && file) this.file = file
    this.#shared = shared
    this.#upload_by = upload_by
    this.#upload_by_type = upload_by_type
  }

  get category() {
    return this.#category
  }
  get type() {
    return this.#type
  }
  get document_type() {
    return this.#document_type
  }
  get issued_by() {
    return this.#issued_by
  }
  get issue_date() {
    return this.#issue_date || new Date()
  }
  get deadline() {
    return this.#deadline || new Date()
  }
  get amount_incl_vat() {
    return this.#amount_incl_vat || '0.00'
  }
  get amount_excl_vat() {
    return this.#amount_excl_vat || '0.00'
  }
  get intervention_date() {
    return this.#intervention_date || new Date()
  }
  get updated_at() {
    return this.#updated_at || new Date()
  }
  get purpose() {
    return this.#purpose
  }
  get url() {
    return this.#url
  }
  get copro_id() {
    return this.#copro_id
  }
  get staff_id() {
    return this.#staff_id
  }
  get provider() {
    return this.#provider
  }
  get shared() {
    if (Array.isArray(this.#shared)) return this.#shared
    return this.#shared.replace(/[{}]/g, '').split(',')
  }
  get invoice_type() {
    return this.#invoice_type
  }
  get upload_by() {
    return this.#upload_by
  }
  get upload_by_type() {
    return this.#upload_by_type
  }
  /**
   * @returns Promise<{
   *    rawFile: File
   *    name: String
   *    src: String
   *    base64?: String
   * }> || undefined
   */
  get file() {
    if (this.#file) return this.#file

    return new Promise((resolve) => {
      resolve()
    })
  }
  get id() {
    return this.#id
  }
  get relation() {
    return this.#relation
  }
  set id(value) {
    this.#id = value

    return this
  }
  set copro_id(value) {
    this.#copro_id = value

    return this
  }
  set staff_id(value) {
    this.#staff_id = value

    return this
  }
  set provider(value) {
    this.#provider = value

    return this
  }
  set category(value) {
    if (this.#requiredField['category'] && !value) throw new Missing('category')

    if (Object.values(FileWithContext.CATEGORY).indexOf(value) === -1)
      throw new InvalidCategory(value)
    this.#category = value

    return this
  }

  set type(value) {
    if (this.#requiredField['type'] && !value) {
      throw new Missing('type')
    }
    this.#type = value
    return this
  }
  set document_type(value) {
    if (this.#requiredField['document_type'] && !value)
      throw new Missing('document_type')
    else if (!value) return

    if (Object.values(FileWithContext.DOCUMENT_TYPE).indexOf(value) === -1)
      throw new InvalidDocumentType(value)
    this.#document_type = value

    return this
  }
  set invoice_type(value) {
    if (this.#requiredField['invoice_type'] && !value)
      throw new Missing('invoice_type')
    else if (!value) return
    if (Object.values(FileWithContext.INVOICE_TYPE).indexOf(value) === -1)
      throw new InvalidInvoiceType(value)
    this.#invoice_type = value

    return this
  }
  set issued_by(value) {
    if (this.#requiredField['issued_by'] && !value)
      throw new Missing('issued_by')

    if (Object.values(FileWithContext.ISSUED_BY).indexOf(value) === -1)
      throw new InvalidIssuedBy(value)
    this.#issued_by = value

    return this
  }
  set issue_date(value) {
    if (this.#requiredField['issue_date'] && !value)
      throw new Missing('issue_date')

    if (value instanceof Date) {
      this.#issue_date = value

      return this
    }
    const tmpDate = moment(value)
    if (typeof value === 'string' && tmpDate.isValid()) {
      this.#issue_date = tmpDate.toDate()

      return this
    }
    throw new InvalidDateFormat(value)
  }
  set deadline(value) {
    if (this.#requiredField['deadline'] && !value) throw new Missing('deadline')
    if (value instanceof Date) {
      this.#deadline = value

      return this
    }
    const tmpDate = moment(value)
    if (typeof value === 'string' && tmpDate.isValid()) {
      this.#deadline = tmpDate.toDate()

      return this
    }
    throw new InvalidDateFormat(value)
  }
  set amount_incl_vat(value) {
    if (this.#requiredField['amount_incl_vat'] && !value)
      throw new Missing('amount_incl_vat')
    if (/^[0-9]+([.,]{1}?[0-9]{2})?$/.test(value)) {
      this.#amount_incl_vat = value

      return this
    }
    throw new InvalidNumberFormat(value)
  }
  set amount_excl_vat(value) {
    if (this.#requiredField['amount_excl_vat'] && !value)
      throw new Missing('amount_excl_vat')
    if (/^[0-9]+([.,]{1}?[0-9]{2})?$/.test(value)) {
      this.#amount_excl_vat = value

      return this
    }
    throw new InvalidNumberFormat(value)
  }
  set intervention_date(value) {
    if (this.#requiredField['intervention_date'] && !value)
      throw new Missing('intervention_date')
    if (value instanceof Date) {
      this.#intervention_date = value

      return this
    }
    const tmpDate = moment(value)
    if (typeof value === 'string' && tmpDate.isValid()) {
      this.#intervention_date = tmpDate.toDate()

      return this
    }
    throw new InvalidDateFormat(value)
  }
  set updated_at(value) {
    if (this.#requiredField['updated_at'] && !value)
      throw new Missing('updated_at')
    if (value instanceof Date) {
      this.#updated_at = value

      return this
    }
    const tmpDate = moment(value)
    if (typeof value === 'string' && tmpDate.isValid()) {
      this.#updated_at = tmpDate.toDate()

      return this
    }
    throw new InvalidDateFormat(value)
  }
  set purpose(value) {
    if (this.#requiredField['purpose'] && !value) throw new Missing('purpose')
    this.#purpose = value

    return this
  }
  set shared(value) {
    if (this.#requiredField['shared'] && !value) throw new Missing('shared')
    this.#shared = value

    return this
  }

  set url(value) {
    this.#url = value

    return this
  }

  /**
   * This function will convert the file into base64 and return it
   *
   * @returns Promise<{
   *    rawFile: File
   *    name: String
   *    src: String
   *    base64?: String
   * }>
   */
  set file(value) {
    // Find a way to do this that do not read the file each time that we try to set the property
    if (!(this.#file instanceof Promise))
      this.#file = new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(value.rawFile)
        reader.onload = () => {
          value.base64 = reader.result
          resolve(value)
        }
        reader.onerror = () => {
          const error = new FileWithContextResult()
          error.rejected_file = new UnableToReadFile(this)

          reject(error)
        }
      })
    return this
  }

  set relation(value) {
    if (value instanceof Relation) this.#relation = value
    else this.#relation = new Relation(value)

    return this
  }

  set upload_by(value) {
    this.#upload_by = value

    return this
  }
  set upload_by_type(value) {
    this.#upload_by_type = value

    return this
  }

  /**
   * Verify requirements
   *
   * @param {Array} requiredProperties An array of the property names that are required
   *
   * @throws Missing exception if there is an empty required property
   *
   * @returns Boolean
   */
  validateRequired(requiredProperties = []) {
    requiredProperties.forEach((propertyName) => {
      if (!this[propertyName]) throw new Missing(propertyName)
    })

    return true
  }

  toJSON() {
    return {
      id: this.id,
      category: this.category,
      type: this.type,
      document_type: this.document_type,
      issued_by: this.issued_by,
      issue_date: this.issue_date,
      deadline: this.deadline,
      copro_id: this.copro_id,
      staff_id: this.staff_id,
      provider: this.provider,
      amount_incl_vat: this.amount_incl_vat,
      amount_excl_vat: this.amount_excl_vat,
      intervention_date: this.intervention_date,
      updated_at: this.updated_at,
      purpose: this.purpose,
      url: this.url,
      file: this.file,
      shared: this.shared,
      invoice_type: this.invoice_type,
      upload_by: this.upload_by,
      upload_by_type: this.upload_by_type,
      ...(this.relation ? this.relation.toJSON() : {}),
    }
  }
}

export default FileWithContext
